export const DATE_TYPE_BY_DTO = [
    'date',
    'creationDate',
    'requestAt',
    'sendAt',
    'startAt',
    'endAt',
    'createdAt',
    'updatedAt',
    'deliveredAt',
    'receivedAt',
    'removeDate',
];
